import { Footprints, Bike, Waves, Dumbbell, Mountain, Moon, Activity } from "lucide-react";

export function sportIcon(sport = "") {
  const s = sport.toLowerCase();
  if (s.includes("run")) return Footprints;
  if (s.includes("cycl") || s.includes("bike")) return Bike;
  if (s.includes("swim")) return Waves;
  if (s.includes("strength") || s.includes("gym")) return Dumbbell;
  if (s.includes("hik") || s.includes("mountain")) return Mountain;
  if (s.includes("rest")) return Moon;
  return Activity;
}

export const intensityColor = {
  rest: "text-muted-foreground bg-muted",
  easy: "text-emerald-600 dark:text-emerald-400 bg-emerald-500/10",
  moderate: "text-brand-yellow bg-brand-yellow/15",
  hard: "text-brand-orange bg-brand-orange/15",
};

export function intensityClass(intensity = "easy") {
  return intensityColor[intensity] || intensityColor.easy;
}

export function fmtDate(iso) {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
}

export const STATUS_LABEL = {
  planned: "Planned",
  completed: "Completed",
  skipped: "Skipped",
};

export function fmtDuration(sec) {
  if (!sec && sec !== 0) return "—";
  const m = Math.round(sec / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}

export function fmtDistance(m) {
  if (!m && m !== 0) return "—";
  return `${(m / 1000).toFixed(2)} km`;
}

export function fmtClock(sec) {
  if (!sec && sec !== 0) return "0:00";
  const s = Math.round(sec);
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
}

// pace in min/km from speed (m/s), as "m:ss"
export function paceFromSpeedMs(ms) {
  if (!ms || ms <= 0) return "—";
  const secPerKm = 1000 / ms;
  const m = Math.floor(secPerKm / 60);
  const s = Math.round(secPerKm - m * 60);
  return `${m}:${String(s).padStart(2, "0")}/km`;
}

// pace in min/km from speed (km/h)
export function paceFromKmh(kmh) {
  if (!kmh || kmh <= 0) return null;
  return 60 / kmh; // decimal minutes per km
}

export function isEndurance(sport = "") {
  const s = sport.toLowerCase();
  return s.includes("run") || s.includes("cycl") || s.includes("bike") || s.includes("swim");
}
